import { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import './_month-selector.scss';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { getDaysInMonth } from '../../utils';
import { AppContext } from '../../contexts';

dayjs.extend(isToday);

const prev = (
  <svg
    width='7'
    height='14'
    viewBox='0 0 7 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {' '}
    <path
      d='M0 1.99994L5 6.99994L0 11.9999L1.414 13.4139L6.414 8.41394C7.195 7.63294 7.195 6.36694 6.414 5.58594L1.414 0.585938L0 1.99994Z'
      fill='#868B91'
    />{' '}
  </svg>
);

const next = (
  <svg
    width='7'
    height='14'
    viewBox='0 0 7 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {' '}
    <path
      d='M0 1.99994L5 6.99994L0 11.9999L1.414 13.4139L6.414 8.41394C7.195 7.63294 7.195 6.36694 6.414 5.58594L1.414 0.585938L0 1.99994Z'
      fill='#868B91'
    />{' '}
  </svg>
);

const MonthSelector = ({ title, onMonthChange, enabledDays, loading, onSelect, loadingDatesMonthView }) => {
  const { currentMonth, setCurrentMonth } = useContext(AppContext);
  const [isTouched, setIsTouched] = useState(false);

  const startOfMonth = dayjs(currentMonth).isValid()
  ? dayjs(currentMonth).startOf('month')
  : dayjs().startOf('month');

  const firstDayOfWeek = startOfMonth.day();
  const daysInMonth = getDaysInMonth(startOfMonth);

  const handlePrev = () => {
    setCurrentMonth(startOfMonth.subtract(1, 'month').format('YYYY-MM-DD'));
  };

  const handleNext = () => {
    setCurrentMonth(startOfMonth.add(1, 'month').format('YYYY-MM-DD'));
  };

  const handleChange = (i) => {
    onSelect(i);
    if (!isTouched) setIsTouched(true);
  };

  useEffect(() => {
    onMonthChange(startOfMonth);
  }, [currentMonth]);

  const renderDay = (day, i) => {
    const isDisabled = day.isBefore(dayjs(), 'day') || !enabledDays.includes(day.date());
    const isToday = day.isToday();
    let cssClass = 'month-selector__date';
    if (isDisabled) cssClass += ' month-selector__date--disabled';
    if(loadingDatesMonthView <= day.date()) cssClass += ' month-selector__date--disabled month-selector__date--loading';
    if (isToday) cssClass += ' month-selector__date--today';
    const formattedDate = day.format('DD-MM-YYYY');

    return (
      <>
      <li className={cssClass} key={formattedDate}>
        <label className='month-selector__date-label'>
          <input
            data-testid='day'
            onChange={handleChange.bind(null, Number(day.format('D')))}
            type='radio'
            className='month-selector__date-input'
            name='date'
            disabled={isDisabled}
          />
          <span className='month-selector__number'>{day.format('D')}</span>
        </label>
      </li>
      </>
    );
  };

  return (
    <div className='month-selector'>
      {title && <h3 className='month-selector__title'>{title}</h3>}
      <div className='month-selector__nav'>
        <p className='month-selector__month-year'>{startOfMonth.format('MMMM YYYY')}</p>
        <div className='month-selector__arrow'>
          <button
            className='month-selector__arrow--prev'
            onClick={handlePrev}
            disabled={
              currentMonth === dayjs().startOf('month').format('YYYY-MM-DD') || loading
            }
          >
            {prev}
          </button>
          <button
            className='month-selector__arrow--next'
            onClick={handleNext}
            disabled={loading}
          >
            {next}
          </button>
        </div>
      </div>
      <div className='month-selector__calendar'>
      <div className='month-selector__weekdays'>
        {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((day) => (
          <span key={day} className='month-selector__weekday'>{day}</span>
        ))}
      </div>
       <ul className='month-selector__dates'>
        {[...Array((firstDayOfWeek + 7) % 7)].map((_, index) => (
          <div key={index} className='month-selector__empty'></div>
        ))}
          {daysInMonth.map((day, index) => renderDay(day, index))}
          </ul>
      </div>
    </div>
  );
};

MonthSelector.propTypes = {
  title: PropTypes.string,
  onMonthChange: PropTypes.func,
  onSelect: PropTypes.func,
  enabledDays: PropTypes.arrayOf(PropTypes.number)
};

export default MonthSelector;
